import D3EFeature from "../models/D3EFeature";
import D3EAppTemplate from "../models/D3EAppTemplate";

export default class FeatureUtils {
  public constructor() {}
  public static getFeaturesByTemplate(
    templates: Array<D3EAppTemplate>
  ): Array<D3EFeature> {
    let features: Array<D3EFeature> = [];

    for (let template of templates) {
      features.addAll(template.features);
    }

    return features;
  }
}
